import React, { useEffect, useRef, useState } from 'react';
import { ArrowUpRight, Menu, MapPin, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTitle, SheetDescription, SheetTrigger } from './ui/sheet';
import { Brand } from './Brand';
import { COMPANY, navigation } from '../data/site';

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('home');
  const pendingSection = useRef(null);
  const navigateMobile = (event, id) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    pendingSection.current = id;
    setOpen(false);
  };
  const afterMenuClose = event => {
    const id = pendingSection.current;
    if (!id) return;
    event.preventDefault();
    pendingSection.current = null;
    // Wait for the drawer's focus trap and scroll lock to be released.
    requestAnimationFrame(() => {
      const section = document.getElementById(id);
      if (!section) return;
      section.tabIndex = -1;
      section.focus({ preventScroll: true });
      window.history.pushState(null, '', `#${id}`);
      section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      setActive(id);
    });
  };
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) setActive(entry.target.id); });
    }, { rootMargin: '-20% 0px -60% 0px' });
    navigation.forEach(({ id }) => { const node = document.getElementById(id); if (node) observer.observe(node); });
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const media = window.matchMedia('(min-width: 1024px)');
    const closeOnDesktop = event => { if (event.matches) setOpen(false); };
    media.addEventListener('change', closeOnDesktop);
    return () => media.removeEventListener('change', closeOnDesktop);
  }, []);
  return (
    <>
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">Pular para o conteúdo</a>
      <div className="utility-bar"><div className="site-container utility-inner">
        <span data-testid="national-coverage"><MapPin size={13} /> Atendimento em todo o Brasil</span>
        <a href={COMPANY.telephone} data-testid="header-phone"><Phone size={13} /> {COMPANY.phone}</a>
      </div></div>
      <header className="site-header" data-testid="site-header">
        <div className="site-container header-inner">
          <a href="#home" aria-label="FATT Elevadores — início" data-testid="header-home"><Brand testId="header-logo" /></a>
          <nav className="desktop-nav" aria-label="Navegação principal">
            {navigation.map(item => <a key={item.id} href={`#${item.id}`} className={active === item.id ? 'active' : ''}
              aria-current={active === item.id ? 'location' : undefined} data-testid={`nav-${item.id}`}>{item.label}</a>)}
          </nav>
          <Button asChild className="fatt-button button-red header-quote"><a href="#contact" data-testid="header-quote">Solicitar orçamento <ArrowUpRight size={17} /></a></Button>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild><Button variant="ghost" className="mobile-toggle" aria-label="Abrir menu de navegação" aria-controls="mobile-navigation" data-testid="mobile-menu-open"><Menu size={25} /></Button></SheetTrigger>
            <SheetContent id="mobile-navigation" className="mobile-panel" closeTestId="mobile-menu-close" onCloseAutoFocus={afterMenuClose} data-testid="mobile-menu">
              <SheetTitle data-testid="mobile-menu-title"><Brand testId="mobile-logo" /></SheetTitle>
              <SheetDescription className="sr-only">Navegação da FATT Elevadores</SheetDescription>
              <nav aria-label="Navegação móvel">
                {navigation.map((item, index) => <a key={item.id} href={`#${item.id}`} onClick={event => navigateMobile(event, item.id)} data-testid={`mobile-nav-${item.id}`}><span>0{index + 1}</span>{item.label}<ArrowUpRight size={20} /></a>)}
              </nav>
              <a className="fatt-button button-red" href="#contact" onClick={event => navigateMobile(event, 'contact')} data-testid="mobile-quote">Solicitar orçamento <ArrowUpRight size={18} /></a>
              <a className="mobile-phone" href={COMPANY.telephone} data-testid="mobile-phone"><Phone size={17} />{COMPANY.phone}</a>
            </SheetContent>
          </Sheet>
        </div>
      </header>
    </>
  );
};